import gsap from 'gsap';
import {
	Sizes,
	generateAnimations,
	animationsKill,
	generateTriggers,
} from '../utils';
import EventEmitter from '../utils/EventEmitter';
import { LoadQueue } from '../utils/loadQueue';

// pending
export class PageLoad extends EventEmitter {
	constructor( options = {} ) {
		super();
		if ( PageLoad.instance ) return PageLoad.instance;
		PageLoad.instance = this;
		// General
		this.sizes = new Sizes();
		this.options = {
			...options,
			devices: options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ],
		};
		this.isEnable = false;

		// Triggers
		this.loadTrigger = {};
		this.loadCompleteTrigger = {};
		this.loadFn = null;
		this.loadCompleteFn = null;
		this.triggerTimer = [];

		// Animations
		this.queue = null;
		this.timelines = null;
		this.allAssets = [];

		this.isComplete = false;

		this.beforeLoad();
	}

	beforeLoad() {
		if (
			this.isEnable ||
			! this.options.devices.includes( this.sizes.device )
		)
			return;
		const loadAssets = this.options.loadAssets;
		const customAssets = this.options.customAssets;
		let assetsType = 'img';
		if (
			loadAssets?.includes( 'image' ) &&
			loadAssets?.includes( 'video' )
		) {
			assetsType = 'img, video';
		} else if ( loadAssets?.includes( 'video' ) ) {
			assetsType = 'video';
		}
		this.allAssets = document.querySelectorAll( assetsType );
		this.queue = new LoadQueue();
		this.allAssets.forEach( ( el ) => {
			if ( el.currentSrc || el.src ) this.queue.loadFile( { el } );
		} );
		if ( loadAssets?.includes( 'custom' ) ) {
			( customAssets || [] ).forEach( ( src ) => {
				if ( src ) this.queue.loadFile( { src } );
			} );
		}
	}

	init() {
		if (
			this.isEnable ||
			! this.options.devices.includes( this.sizes.device )
		)
			return;

		const [ timelines ] = generateAnimations(
			null,
			this.options.animations
		);
		this.timelines = timelines;

		const loadSettings = this.options.loading;
		const completeSettings = this.options.loadComplete;

		this.loadFn = generateTriggers(
			loadSettings,
			timelines,
			this.loadTrigger,
			this.triggerTimer,
			0
		);

		this.loadCompleteFn = generateTriggers(
			completeSettings,
			timelines,
			this.loadCompleteTrigger,
			this.triggerTimer,
			0
		);

		if ( loadSettings ) {
			this.loadTrigger.toggle?.[ 0 ]?.run();
			this.loadTrigger.attribute?.[ 0 ]?.run();
			if ( loadSettings.animation ) {
				const animationID = loadSettings.animation.theAnimation;
				const action = loadSettings.animation.action || 'play';
				const timeline = this.timelines.find(
					( item ) => item.animationID === animationID
				)?.timeline;
				let isCounter = false;
				let counterTarget = null;
				if ( this.queue?.numItems ) {
					const theAnimation = this.options.animations.find(
						( item ) =>
							item.animationID ===
							loadSettings.animation.theAnimation
					);
					let i = 0;
					while ( i < theAnimation.clips.length ) {
						const theClip = theAnimation.clips[ i ];
						if (
							theClip.to?.hasOwnProperty( 'text' ) ||
							theClip.to?.hasOwnProperty( 'textContent' )
						) {
							isCounter = true;
							counterTarget = theClip.target[ 0 ];
							i = theAnimation.clips.length;
						} else if (
							theClip.from?.hasOwnProperty( 'text' ) ||
							theClip.from?.hasOwnProperty( 'textContent' )
						) {
							isCounter = true;
							counterTarget = theClip.target[ 0 ];
							i = theAnimation.clips.length;
						} else {
							i++;
						}
					}
					const textElement = document.querySelector( counterTarget );
					let progressVal = 0;
					this.queue.on( 'progress', ( e ) => {
						progressVal = Math.floor( e.progress * 100 );
						gsap.to( timeline, {
							progress: progressVal / 100,
							onUpdate: () => {
								const tlProgress = timeline.progress();
								if ( isCounter ) {
									textElement.textContent = Math.floor(
										tlProgress * 100
									);
								}
								if ( tlProgress >= 1 ) {
									this.trigger( 'ready' );
									this.loadCompleteFn?.run();
								}
							},
						} );
					} );
				} else {
					timeline?.[ action ]();
				}
			}
		} else if ( ! loadSettings && completeSettings ) {
			if ( ! this.queue?.numItems ) {
				this.trigger( 'ready' );
				this.loadCompleteFn?.run();
				this.isComplete = true;
			} else {
				this.queue.on( 'complete', () => {
					this.trigger( 'ready' );
					this.loadCompleteFn?.run();
					this.isComplete = true;
				} );
			}
		} else if ( ! loadSettings && ! completeSettings ) {
			this.trigger( 'ready' );
			this.isComplete = true;
		}
		this.isEnable = true;
	}

	kill() {
		if ( ! this.isEnable ) return;
		animationsKill( null, this.options.animations );
		this.timelines.forEach( ( item ) => {
			item.timeline?.kill();
		} );
		this.timelines = null;
		this.allAssets = [];
		this.isEnable = false;
	}

	resize() {
		this.kill();
		this.init();
	}

	destroy() {
		this.kill();
		this.sizes = null;
		this.options = null;
		this.allAssets = null;
		this.isEnable = null;
	}
}
